/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BagBriefcaseIcon20Solid = forwardRef('BagBriefcaseIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.563 1.25A2.562 2.562 0 0 0 5 3.813V5H3a2 2 0 0 0-2 2v2.017l8.353 2.506a2.25 2.25 0 0 0 1.293 0L19 9.017V7a2 2 0 0 0-2-2h-2V3.812a2.563 2.563 0 0 0-2.563-2.562H7.564ZM13 5V3.812a.562.562 0 0 0-.563-.562H7.564A.563.563 0 0 0 7 3.813V5h6Z" }),
        React.createElement("path", { d: "M2 14.5v-3.617l6.922 2.077c.703.21 1.453.21 2.156 0L18 10.883V14.5a3.5 3.5 0 0 1-3.5 3.5h-9A3.5 3.5 0 0 1 2 14.5Z" })));
});
